import type { HttpErrorResponse } from '@angular/common/http';

import { ConversationNormalisedError } from '../models/conversation-normalised-error.model';

export function normaliseConversationError(
  error: HttpErrorResponse | unknown,
  intent: 'read' | 'write' = 'read'
): ConversationNormalisedError {
  const httpError = error as HttpErrorResponse;
  const status = httpError?.status ?? 0;
  const backendCode =
    httpError?.error?.code || httpError?.error?.error || httpError?.statusText;

  if (status === 401) {
    return {
      status,
      code: String(backendCode || 'unauthenticated'),
      translationKey: 'conversation.registration_required_on_submit',
      details: httpError?.error,
    };
  }

  if (status === 403) {
    return {
      status,
      code: String(backendCode || 'forbidden'),
      translationKey:
        intent === 'write'
          ? 'conversation.cannot_write'
          : 'conversation.cannot_read',
      details: httpError?.error,
    };
  }

  if (status === 404) {
    return {
      status,
      code: String(backendCode || 'not_found'),
      translationKey: 'conversation.no_conversation_yet',
      details: httpError?.error,
    };
  }

  if (status === 422) {
    return {
      status,
      code: String(backendCode || 'unprocessable_entity'),
      translationKey: 'error.not_done_try_again',
      details: httpError?.error,
    };
  }

  return {
    status,
    code: String(backendCode || 'unknown_error'),
    translationKey: 'error.something_went_wrong',
    details: httpError?.error || error,
  };
}
